export const FETCH_UTILISATEUR_TEST_REQUEST     = "FETCH_UTILISATEUR_TEST_REQUEST";
export const FETCH_UTILISATEUR_TEST_SUCCESSFUL  = "FETCH_UTILISATEUR_TEST_SUCCESSFUL";
export const FETCH_UTILISATEUR_TEST_FAILURE     = "FETCH_UTILISATEUR_TEST_FAILURE";

export const UPDATE_UTILISATEUR_TEST_REQUEST     = "UPDATE_UTILISATEUR_TEST_REQUEST";
export const UPDATE_UTILISATEUR_TEST_SUCCESSFUL  = "UPDATE_UTILISATEUR_TEST_SUCCESSFUL";
export const UPDATE_UTILISATEUR_TEST_FAILURE     = "UPDATE_UTILISATEUR_TEST_FAILURE";

export const UPDATE_UTILISATEUR_TEST_ELAPSED_TIME     = "UPDATE_UTILISATEUR_TEST_ELAPSED_TIME";